import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block"],
    ["link", "image"],
    ["clean"]
  ]
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "blockquote",
  "code-block",
  "link",
  "image"
];

export default function WysiwygEditor({
  value,
  onChange,
  placeholder = "Escreva aqui..."
}) {
  return (
    <div className="wysiwyg-wrapper">
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        modules={modules}
        formats={formats}
      />

      {/* 🔥 CSS LOCAL PARA ALTURA */}
      <style>{`
        .wysiwyg-wrapper .ql-container {
          min-height: 320px;
          font-size: 15px;
        }

        .wysiwyg-wrapper .ql-editor {
          min-height: 300px;
          line-height: 1.7;
          padding: 16px;
        }

        .wysiwyg-wrapper .ql-toolbar {
          border-radius: 8px 8px 0 0;
        }

        .wysiwyg-wrapper .ql-container {
          border-radius: 0 0 8px 8px;
        }
      `}</style>
    </div>
  );
}
